<script>
  export default {
    name: 'BasePageForm',
    props: {
      title: {
        type: String,
        default: '页面标题',
      },
    },
    data() {
      return {};
    },
  };
</script>

<template>
  <div class="page-form">
    <header class="title">
      <slot name="header">
        <i class="el-icon-back" style="font-size: 26px;cursor: pointer" @click="$emit('back')" />
        <h3 style="margin-left: 10px">{{ title }}</h3>
        <div class="header-actions">
          <slot name="header-actions"></slot>
        </div>
      </slot>
    </header>

    <main class="main-content">
      <slot name="main"></slot>
    </main>

    <footer class="footer">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<style scoped lang="scss">
  .page-form {
    display: flex;
    flex-direction: column;
    padding: 10px;
    .title {
      height: 54px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      width: 100%;
      z-index: 999;
    }

    .main-content {
      max-height: calc(100vh - 200px);
      background-color: #fff;
      flex: 1;
      overflow: auto;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE 10+ */
      padding: 20px;
      margin-top: 10px;
    }

    .footer {
      display: flex;
      height: 54px;
      justify-content: center;
      align-items: center;
      border-top: 1px solid #e4e4e4;
      background: #fff;
    }
  }
</style>
